export const Mode = {
  FULL: 'full',
  STICKY: 'sticky',
} as const;

export type Mode = Union<typeof Mode>;
